<template>
  <div>
    <list-card avatar
               hide-search
               hide-title
               show-all
               item-route-name="supplier"
               two-line
               v-bind:items="items"
               v-bind:loading="loading"
               v-bind:title="$t('suppliers')">
      <template v-slot:item-prepend="{ item }">
        <v-list-item-avatar class="sf-avatar"
                            v-bind:title="$t('boothNumber')">
          <span>{{ item.boothNumber }}</span>
        </v-list-item-avatar>
      </template>
      <template v-slot:item-append="{ item }">
        <v-chip v-bind:class="[ 'sf-pill', `sf-pill--${pillVariant(getBadge0Color(item))}` ]"
                small
                v-if="item.hasDeliveryPeriod0Orders">
          {{ item.deliveryPeriod0Tag | defaultValue($t('period1')) }}
        </v-chip>
        <v-chip class="ml-1"
                v-bind:class="[ 'sf-pill', `sf-pill--${pillVariant(getBadge1Color(item))}` ]"
                small
                v-if="item.hasDeliveryPeriod1Orders && item.deliveryPeriod1Tag != null && item.deliveryPeriod1Tag.length !== 0">
          {{ item.deliveryPeriod1Tag | defaultValue($t('period2')) }}
        </v-chip>
      </template>
    </list-card>
  </div>
</template>

<script>
  import ListCard from '@/components/common/ListCard'

  export default {
    components: {
      ListCard
    },
    computed: {
      items() {
        console.log(this.suppliers.map(s => s.boothNumber))
        return [...this.suppliers].map(s => ({
          ...s,
          title: s.supplierGroup ?? s.companyName,
          grey: s.id == this.lastSupplierId,
          boothNumber: s.boothNumber != null ? s.boothNumber : ''
        }))
      }
    },
    methods: {
      pillVariant(color) {
        return { 'light-green': 'success', orange: 'warning', accent: 'accent' }[color] || 'neutral'
      },
      getBadge1Color(item) {
        if (item.hasDeliveryPeriod1OrdersNonStandard) {
          return 'light-green'
        }

        if (item.hasDeliveryPeriod1OrdersNonNull) {
          return 'orange'
        }

        if (item.hasDeliveryPeriod1Orders) {
          return 'accent'
        }

        return null
      },
      getBadge0Color(item) {
        if (item.hasDeliveryPeriod0OrdersNonStandard) {
          return 'light-green'
        }

        if (item.hasDeliveryPeriod0OrdersNonNull) {
          return 'orange'
        }

        if (item.hasDeliveryPeriod0Orders) {
          return 'accent'
        }
      }
    },
    name: 'SupplierPresentationList',
    props: {
      suppliers: Array,
      lastSupplierId: String,
      loading: Boolean
    }
  }
</script>

<i18n>
  {
    "de": {
      "ordered": "Bestellt",
      "period1": "Zeitraum 1",
      "period2": "Zeitraum 2",
      "suppliers": "Lieferanten",
      "boothNumber": "Standnummer"
    },
    "en": {
      "ordered": "Ordered",
      "period1": "Period 1",
      "period2": "Period 2",
      "suppliers": "Suppliers",
      "boothNumber": "Booth number"
    }
  }
</i18n>